'use client';

import { useParams, usePathname, useSearchParams } from 'next/navigation';
import styles from '../product-comparison-grid.module.scss';
import cx from 'classnames';
import { SCROLL_TO_PRODUCT_PARAM } from 'hooks/use-filter/constants/common';
import { ProductsPriceData } from 'app/[lang]/[esite]/(core)/(search-display)/_components/analytics-listener/types';
import { getPDPUrl, getSelectedItem } from './utils';
import Link from 'next/link';
import { MouseEvent } from 'react';
import { useSelectItemEvent } from 'hooks/analytics/use-select-item-event';
import { OrderItemPart } from 'services/cart';

export interface ProductCardTitleProps {
  productName: string;
  productNumber: string;
  href: string;
  className?: string;
  productPriceData?: ProductsPriceData;
  isHeadlessPDPEnabled?: boolean;
  locationId?: string;
  orderItem?: OrderItemPart | { orderItemId: string };
  serialNumber?: string;
  fitmentCheck?: string;
  cartId?: string | number;
}

const ProductCardTitle = ({
  productName,
  productNumber,
  href,
  className = 'cat-u-theme-typography-label-lg',
  productPriceData,
  isHeadlessPDPEnabled,
  orderItem,
  locationId,
  serialNumber,
  fitmentCheck,
  cartId
}: ProductCardTitleProps) => {
  /*  TODO - Input Validations - useSearchParams: The params object should contain key value pairs where
  the value is of string type, not including reservered url special / unsafe characters like / \ & ? = : % + ' " ; < > { } [ ] @ #
  */
  const params = useSearchParams();
  /*
    TODO - Input Validations - usePathName: string except the
    generalRestrictedCharacters (@\constants\securityConstants.ts)
  */
  const pathname = usePathname();
  const { fireEvent: fireSelectItemEvent } = useSelectItemEvent();
  // TODO - Input Validation - Ensure that all values used from esiteParams are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const esiteParams = useParams();
  const pdpURL = getPDPUrl({
    esiteParams,
    isHeadlessPDPEnabled,
    productNumber,
    productURL: href
  });

  const handleClick = (e: MouseEvent) => {
    if (!isHeadlessPDPEnabled) {
      e.preventDefault();
      window.location.href = pdpURL;
    }

    productPriceData &&
      fireSelectItemEvent(
        getSelectedItem({
          productPriceData,
          locationId,
          cartId,
          serialNumber,
          fitmentCheck
        })
      );

    const newParams = new URLSearchParams(params.toString());
    newParams.set(SCROLL_TO_PRODUCT_PARAM, productNumber);
    const newURL = `${pathname}?${newParams.toString()}`;
    window.history.pushState(null, null, newURL);
  };

  return (
    <Link
      href={pdpURL}
      className={cx('border-0', styles['product-comparison__card-title'])}
      onClick={handleClick}
    >
      <h2
        className={cx(
          className,
          'm-0',
          styles['product-comparison__card-ellipsis']
        )}
      >
        {productNumber}: {productName}
      </h2>
    </Link>
  );
};

export default ProductCardTitle;
